// extracted by mini-css-extract-plugin
module.exports =  {"explanation":"explanation_ZYRJDNyP"};